import { create } from 'apisauce';
import { makeObservable, observable } from 'mobx';
import DeliveryStore from './DeliveryStore';
import PODStore from './podStore';
import { defaultTheme } from '../themes';
import { getCookie } from 'utils/cookie';

const createAPI = (baseURL) => {
  return create({
    baseURL,
    withCredentials: true,
  });
};

const interceptorConfig = (config) => {
  const token = getCookie('axl_shipment_token');
  if (token && !config.headers['Authorization']) config.headers['Authorization'] = `TToken AXL_${token}`;

  return config;
};

class AppStore {
  // no-dd-sa:javascript-best-practices/no-unreachable
  pageTheme = defaultTheme;

  constructor() {
    makeObservable(this, {
      pageTheme: observable,
    });

    this.api = createAPI(import.meta.env.REACT_APP_API_ROOT);
    this.api.axiosInstance.interceptors.request.use((config) => {
      return interceptorConfig(config);
    });

    this.apiDataOrch = createAPI(import.meta.env.REACT_APP_DATAORCH);
    this.apiDataOrch.axiosInstance.interceptors.request.use((config) => {
      return interceptorConfig(config);
    });

    this.deliveryStore = new DeliveryStore(this);
    this.podStore = new PODStore(this);
  }
}

export default AppStore;
